export const CART_ADD_ITEM = '@cart/CART_ADD_ITEM';
export const CART_CLEAR = '@cart/CLEAR';
